import { render, staticRenderFns } from "./OverviewThree.vue?vue&type=template&id=670b32a0"
import script from "./OverviewThree.vue?vue&type=script&lang=js"
export * from "./OverviewThree.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@nuxt/webpack/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {UtilHeadingAdvanced: require('/srv/app/components/util/HeadingAdvanced.vue').default,CardIcon: require('/srv/app/components/card/CardIcon.vue').default,ButtonLink: require('/srv/app/components/button/Link.vue').default})
